import axios from 'axios';
import { PRODUCT_TYPE } from '../../utils/enum';
import { getApiUrl } from '../baseUrl';


export const getApiDetails = () => {
    return axios.get(getApiUrl() + '/api_explorer/getApiDetails')
}

export const submitApiRequest = (productType, url, params) => {
    return axios.post(PRODUCT_TYPE[productType] + url, params)
}

export const getApiConsumption = () => {
    return axios.get(process.env.REACT_APP_API_EXPLORER_BASE_URL+'/credit_usage_details')
}

export const getAPIexplorerAutoSuggest = (url) => {
    return axios.get(process.env.REACT_APP_API_BASE_URL + url)
}